export const createLink = (template, params) => {
    for (let key in params) {
        template = template.replace(key, params[key]);
    }
    return template;
};
